import React from 'react';
import { AuthContext, Login } from '../auth';

export const Home: React.FC = () => {
  const authContext = React.useContext(AuthContext);
  if (authContext.auth === false) {
    return <Login />;
  }
  return <div>Hello {authContext.user.email}</div>;
};
